function createStorageError(storeType, action) {
    let storageName;
    switch (storeType) {
        case 'localStorage':
            storageName = 'local';
            break;
        case 'sessionStorage':
            storageName = 'session';
            break;
        case 'custom':
            storageName = 'custom';
            break;
        default:
            break;
    }
    return {
        error: `${action}_error`,
        message: `Error ${action.toLowerCase()} value from ${storageName} storage`,
        type: action === 'Parsing' ? 'parse_error' : 'unknown_error',
    };
}
export function createStorage(config) {
    const { type: storeType, prefix = 'pic', name } = config;
    const key = `${prefix}-${name}`;
    const storageTypes = {
        sessionStorage,
        localStorage,
    };
    if (storeType === 'custom' && !('custom' in config)) {
        throw new Error('Custom storage configuration must include a custom storage object');
    }
    return {
        get: async function storageGet() {
            if (storeType === 'custom') {
                let value;
                try {
                    value = await config.custom.get(key);
                }
                catch {
                    return createStorageError(storeType, 'Retrieving');
                }
                if (value === null || (typeof value === 'object' && 'error' in value)) {
                    return value;
                }
                try {
                    const parsed = JSON.parse(value);
                    return parsed;
                }
                catch {
                    return createStorageError(storeType, 'Parsing');
                }
            }
            let value;
            try {
                value = await storageTypes[storeType].getItem(key);
                if (value === null) {
                    return value;
                }
            }
            catch {
                return createStorageError(storeType, 'Retrieving');
            }
            try {
                const parsed = JSON.parse(value);
                return parsed;
            }
            catch {
                return createStorageError(storeType, 'Parsing');
            }
        },
        set: async function storageSet(value) {
            const valueToStore = JSON.stringify(value);
            if (storeType === 'custom') {
                try {
                    const result = await config.custom.set(key, valueToStore);
                    return result ?? null;
                }
                catch {
                    return createStorageError(storeType, 'Storing');
                }
            }
            try {
                await storageTypes[storeType].setItem(key, valueToStore);
                return Promise.resolve(null);
            }
            catch {
                return createStorageError(storeType, 'Storing');
            }
        },
        remove: async function storageRemove() {
            if (storeType === 'custom') {
                try {
                    const result = await config.custom.remove(key);
                    return result ?? null;
                }
                catch {
                    return createStorageError(storeType, 'Removing');
                }
            }
            try {
                await storageTypes[storeType].removeItem(key);
                return Promise.resolve(null);
            }
            catch {
                return createStorageError(storeType, 'Removing');
            }
        },
    };
}
